import React, { useEffect, useState } from "react";
import classnames from "classnames";

import { updateFn } from "../shared/events";

const Input = (props) => {
    const [value, setValue] = useState((props.valueToTransfer ? props.valueToTransfer : props.defaultValue ? props.defaultValue : props.value) || "");

    useEffect(() => {
        const newValue = (props.defaultValue ? props.defaultValue : props.value) || "";

        if (props.onValidatePair && newValue) {
            props.onValidatePair(newValue);
        }

        if (newValue !== value) {
            setValue(newValue);
        }
    }, [props.defaultValue, props.value]);

    const onChange = (e) => {
        setValue(e.currentTarget.value);

        if (props.onValidatePair) {
            props.onValidatePair(e.target.value);
        }

        if (props.onChange) {
            props.onChange(e);
        } else if (props.updateOnChange) {
            updateFn(props.updateOnChange)(e);
        }
    };

    return (
        <input
            type="text"
            key={`${props.id || props.name || ""}`}
            id={`${props.id || props.name || ""}`}
            name={props.name}
            autoComplete={props.autoComplete}
            autoFocus={props.autoFocus}
            min={props.min}
            max={props.max}
            maxLength={props.maxLength}
            minLength={props.minLength}
            multiple={props.multiple}
            pattern={props.pattern}
            placeholder={props.placeholder}
            readOnly={props.readOnly}
            required={props.required}
            step={props.step}
            value={value}
            onKeyPress={props.onKeyPress}
            onKeyUp={props.onKeyUp}
            onChange={onChange}
            onBlur={props.onBlur || updateFn(props.updateOnBlur)}
            onFocus={props.onFocus}
            disabled={props.disabled}
            tabIndex={props.tabIndex}
            className={classnames({ "-error": props.invalid })}
        />
    );
};

export default Input;
